import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { PageSize, PaginationObject } from '@maced/angular-components/lib/pagination/pagination.model';
import { ActivatedRoute, Router } from '@angular/router';
import { columnHeader, columnMappings, newTableHeader, newTableStudentData, newTextColumnHeaders, numericTableHeader, studentData, tableData, tableDataWithoutNumbers, tableDataWithText, tableStudentDataWithNumericInput, tableStudentDataWithTextArea, textAreaTableHeader, textColumnHeaders, withoutSubHeaders, withoutSubHeadersStudentData, maxSmallScreenMobileSize, TableRowaData, TableHeaderData, ScrollableTableHeaderData, ScrollableTableRowaData, tableDataWithDifferentModes, ScrollableCustomTableHeaderData, ScrollableCustomTableRowaData, ptTableCustomHeader, ptTableCustomStudentData } from './table.constants';
import { delay, of, Subscription } from 'rxjs';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AriaLabels } from '@maced/angular-components/lib/error-state/error-state-interface';
import { Placement } from '@popperjs/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html'
})
export class TableComponent implements OnInit  {
  title3 = 'No results have been found';
  id3 = 'errorContainer3';
  imageUrl3 = '/assets/default/images/error_blue/No-search-results.svg';
  ariaLabels: AriaLabels = {
    imageAltText: 'banner-image'
  };
  searchInputLabelEnglish = { submitlabel: 'Submit', close: 'Clear', search: 'search' };
  data = tableData;
  mappings = columnMappings;
  dataWithoutNumerics = tableDataWithoutNumbers;
  headers = columnHeader;
  tableDataWithText = tableDataWithText;
  textColumnHeaders = textColumnHeaders;
  newTextColumnHeaders = newTextColumnHeaders;
  studentData = studentData;
  withoutSubHeaders = withoutSubHeaders;
  withoutSubHeadersStudentData = withoutSubHeadersStudentData;
  newTableHeader = newTableHeader;
  newTableStudentData = newTableStudentData;
  textAreaTableHeader = textAreaTableHeader;
  tableStudentDataWithTextArea = tableStudentDataWithTextArea;
  tableStudentDataWithNumericInput = tableStudentDataWithNumericInput;
  numericTableHeader = numericTableHeader;
  rowsData = TableRowaData;
  headerData =  TableHeaderData;
  scrollableTableHeaderData = ScrollableTableHeaderData;
  scrollableTableRowaData = ScrollableTableRowaData;
  tableDataWithDifferentModes = tableDataWithDifferentModes;
  ScrollableCustomTableHeaderData = ScrollableCustomTableHeaderData;
  ScrollableCustomTableRowaData = ScrollableCustomTableRowaData;
  ptTableCustomHeader= ptTableCustomHeader;
  ptTableCustomStudentData= ptTableCustomStudentData;
  newStudentData:any;
  sortingOrder = 'ascending';
  paginationObject!: PaginationObject;
  nestedTablepaginationObject!: PaginationObject;
  paginationNewObject!: PaginationObject;
  pageSizeList: PageSize[] = [];
  currentUrl: string;
  pageSize = 5;
  currentPage = 1;
  newData: any;
  isDesc: boolean = true;
  column: string = 'CategoryName';
  label = '0 items selected' as string;
  numaricLabel = '0 questions selected' as  string;
  selectedList: any;
  hasDigitalTest = true;
  hasPaperTest = true;
  hasRadio = true;
  hasCheckbox = true;
  isBrowser = true;
  withoutScrollBar = true;
  tableWithoutScrollBar = false
  captionLable = 'Choose Formate';
  buttonAriaLabel = 'Download';
  columnAlignment = 'left'
  private queryParamSubscription!: Subscription;
  routeSubscription: Subscription;
  screenSize: number = 1024;
  minimumScreenResolution = maxSmallScreenMobileSize.maxSmallScreenMobileSize;
  isSearch = false as boolean;
  completeStudentData = studentData;
  ariaExpanded = false;
  useCase = 'tableWithPaginationHeaderAndNumerics';
  selectedUseCase = 'tableWithPaginationHeaderAndNumerics';
  useCases: string[] = [
    'tableWithPaginationHeaderAndNumerics',
    'tableWithOutPaginationHeaderAndNumerics',
    'tableWithoutRadioAndCheckbox', 
    'tableBodyWithStaticData',
    'tableWithoutCheckboxAndFixedColumns',
    'tableBodyWithStaticData2',
    'tableBodyWithStaticDataAndNumaricInput',
    'tableWithNestedRows',
    'tableNestedRowsWithScroll',
    'tableWithAllModes',
    'tableWithCustomizedRow',
    'tablecustom'
  ];
  link: { label: string, hyperLink: string } = { label: 'Action', hyperLink: '/button' };

  currentSortKey: string | null = null;   // e.g., 'teacher', 'course', 'average'
  sortDirection: 'asc' | 'desc' = 'asc';

  @HostListener('window:resize', ['$event'])
  options1: DropdownOption[] = [
    {
      id: '1',
      name: 'Digital Test',
      label: 'Digital Test',
      disabled: true
    },
    {
      id: '2',
      name: 'Paper Test',
      label: 'Paper Test',
      disabled: true
    }];
    options2: DropdownOption[] = [
      {
        id: '1',
        name: 'Enter 0',
        label: 'Enter 0',
        disabled: true
      },
      {
        id: '2',
        name: 'Enter the max score',
        label: 'Enter the max score',
        disabled: true
      }]
    options4: DropdownOption[] = [
      {
        id: 'option41',
        name: 'option41',
        label: 'option 41',
        url: '/dropdown'
      },
      {
        id: 'option42',
        name: 'option42',
        label: 'option 42',
        url: '/dropdown'
      },
      {
        id: 'option43',
        name: 'option43',
        label: 'option 43',
        url: '/dropdown'
      }
    ];

    sortByDropdown: DropdownOption[] = [
      {
        id: 'a-z',
        name: 'option11',
        label: 'First Name (A-Z)',
        url: '/table'
      },
      {
        id: 'z-a',
        name: 'option12',
        label: 'First Name (Z-A)',
        url: '/table'
      }
    ];
    viewBydropdown: DropdownOption[] = [
      {
        id: '1',
        name: 'first',
        label: 'First',
        url: '/table'
      },
      {
        id: '2',
        name: 'second',
        label: 'Second',
        url: '/table'
      },
      {
        id: '3',
        name: 'third',
        label: 'Third',
        url: '/table'
      },
      {
        id: '4',
        name: 'fourth',
        label: 'Fourth',
        url: '/table'
      }
    ];

    sortByList = [{
      id: 'a-z',
      label: 'First Name (A-Z)',
      checked: 'First Name (A-Z)'
    }, {
      id: 'z-a',
      label: 'First Name (Z-A)',
      checked: ''
    }];
    viewByList = [{
      id: 1,
      label: 'First',
      checked: ''
    }, {
      id: 2,
      label: 'Second',
      checked: ''
    }, {
      id: 3,
      label: 'Third',
      checked: ''
    }, {
      id: 4,
      label: 'Fourth',
      checked: 'Fourth'
    }]
    viewBydropdownselectedOptions!: any;
    sortByDropdownselectedOptions!: any;
    selectedOptions4!: DropdownOption;
    selectedFilterList: any;
    FilterDropdown: DropdownOption[] = [
      {
        id: 'view',
        name: 'view',
        label: 'View',
        url: '/table'
      },
      {
        id: 'give',
        name: 'give',
        label: 'Give',
        url: '/table'
      }
    ];
    FilterDropdownselectedOptions!: any;
    selectedPlacement: Placement = 'bottom-end';
    buttonList = [
      {
        id: 'clearAll',
        name: 'clearAll',
        label: 'Clear Filter',
        url: '/table',
        hasClearButton: true,
        disabled: false,
        queryParams: { 'ButtonId': 'clear' }
      },
      {
        id: 'apply',
        name: 'apply',
        label: 'Apply Filter',
        url: '/table',
        hasApplyButton: true,
        disabled: false,
        queryParams: { 'ButtonId': 'apply' }
      }];
      
    link2: { label: string, hyperLink: string, target: string } =
    { label: 'view', hyperLink: '/button', target: '_self' };
    backIconClass = 'icon-eye';
    formElement!: FormGroup;
  filteredData: any;
  showNotificationInline = false as boolean;
  constructor(
    public el: ElementRef,
    @Inject(PLATFORM_ID) public platformId: any,
    private formBuilder: FormBuilder,
    private router: Router, private route: ActivatedRoute
  ) {
    this.currentUrl = this.router.url.split('?')[0];
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      this.screenSize = window.innerWidth;      
    } else{
      this.isBrowser = false;
    }
    this.routeSubscription = this.route.queryParams.subscribe(param => {
      (param.sortingOrder == 'descending') ? this.isDesc = true : this.isDesc = false;
      if (param.sortingId) {
        this.sortingOrder = param.sortingOrder
        this.setPageintaionObject();
        this.setNewPageintaionObject();
        this.sortEvent(param.sortingId, param.tableId);
      }
    });
    this.nestedTablepaginationObject = {
      totalItems: 5,
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      totalPages: Math.ceil(this.data.length / this.pageSize)
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenSize = event.target.innerWidth;
    if(this.isBrowser && this.screenSize <= this.minimumScreenResolution){
      this.mobileFilteredList();
    }else{
      this.desktopFilteredList();
    }
  }
  
  ngOnInit(): void {
    this.formElement = this.formBuilder.group({
      inputVal: [''],

    });
    if(this.isBrowser && this.screenSize <= this.minimumScreenResolution){
      this.mobileFilteredList();
    }
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {

        if (param.notificationInlineId) {
          this.showNotificationInline = (param.isOpen === "true");
          document.getElementById('NotificationInlineButton')?.focus();
        }
      if(!this.isBrowser && param.input){
        this.onSearchSubmit(param.input);
      }
      if (param.dropdownId && param.dropdownId === 'sortBy') {
        this.sortByDropdown.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.sortByDropdownselectedOptions = obj;
          this.studentData = studentData;
          this.filterMobileView();
            this.sortStudentData(this.sortByDropdownselectedOptions);
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'viewBy') {
        this.viewBydropdown.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.viewBydropdownselectedOptions = obj;
            this.studentData = studentData;
            this.filterMobileView();
            this.viewbyList(this.viewBydropdownselectedOptions)
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'FilterDropdownId') {
        this.FilterDropdown.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.FilterDropdownselectedOptions = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.ButtonId && param.ButtonId === 'clear') {
        this.selectedFilterList = [];
        this.router.navigate([], {
          queryParams: {
            'dropdownId': null,
            'selectedDropdownOptionId': null,
            'ButtonId': null
          },
          queryParamsHandling: 'merge'
        });
        this.sortByList.forEach((obj) => {
          obj.checked = ''
        });
        this.viewByList.forEach((obj) => {
          obj.checked = ''
        });
        this.FilterDropdown.forEach((obj) => {
          obj.active = false;
        });
        this.studentData = studentData;
        this.FilterDropdownselectedOptions = { label: 'Please select' }
      }
      if (param.ButtonId && param.ButtonId === 'apply') {
        if(this.isBrowser && this.isMobileWidth()){
          this.mobileFilteredList();
        }else{
          this.desktopFilteredList();
        } 
        this.filteredList(this.FilterDropdownselectedOptions);  
      }
      if (param?.currentPage || (param?.selectedDropdownOptionId && param.dropdownId && param.dropdownId === 'paginationIdPageSizeList')) {
        this.currentPage = param.currentPage ? +param.currentPage : this.currentPage;
        if (param.currentPage && param.selectedDropdownOptionId && param.dropdownId && param.dropdownId === 'paginationIdPageSizeList' && param.selectedDropdownOptionId !== JSON.stringify(this.pageSize)) {
          this.currentPage = 1
        }
        this.pageSize = (param?.selectedDropdownOptionId && param.dropdownId && param.dropdownId === 'paginationIdPageSizeList') ? +param.selectedDropdownOptionId : this.pageSize;
        this.setPageintaionObject();
        this.setNewPageintaionObject();
        this.setPageSizeList();
      } else {
        this.setPageintaionObject();
        this.setNewPageintaionObject();
        this.setPageSizeList();
      }
      this.buttonList.forEach((obj:any)=>{
        if((this.FilterDropdownselectedOptions && this.FilterDropdownselectedOptions.id) || (this.selectedFilterList && this.selectedFilterList.length > 0)){
          obj.disabled = false;
        }else{
          obj.disabled = true;
        }
      });
    });  
    this.onChange()
  }

  ngDoCheck(){
    if(this.isBrowser){
      if(document.getElementById('floatingpanel1')?.hasAttribute('data-show')){
        this.ariaExpanded = true;
      }else{
        this.ariaExpanded = false;
      }
      document.getElementById('floatingpanel1')?.removeAttribute('role');
    }
  }

  saveData(){
    let tableRowCalsses = this.el.nativeElement.getElementsByClassName('c-table__row-column-form');
    Array.from(tableRowCalsses).forEach(element => {
    if((element as any).classList.contains('c-table__row-column-modified')){
      (element as any).classList.remove('c-table__row-column-modified')
    }
  })
  }
  
  isMobileWidth() {
    if (isPlatformBrowser(this.platformId)) {
      return window?.innerWidth < this.minimumScreenResolution
    }
    else {
      return false;
    }
  }

  desktopFilteredList(){
    this.selectedFilterList = [];
    this.FilterDropdown.forEach((obj) => {
      if (obj.active === true) {
        this.selectedFilterList.push(obj)
      }
    });
  }

  mobileFilteredList(){
    this.selectedFilterList = [];
    this.desktopFilteredList();
      this.sortByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedFilterList.push(obj)
        }
      });
      this.viewByList.forEach((obj) => {
        if (obj.checked !== '') {
          this.selectedFilterList.push(obj)
        }
      });
  }

  buttonFocus(){
    if(!document.getElementById('floatingpanel1')?.hasAttribute('data-show')){
      document.getElementById('buttonId3')?.focus();
      document.getElementById('buttonId1')?.focus();
    }
  }

  setPageintaionObject(): void {
    let startIndex = (this.currentPage - 1) * this.pageSize;
    let endindex = this.currentPage * this.pageSize;
    if (this.data.length > 0) {
      this.newData = this.data.slice(startIndex, endindex);
    }
    this.paginationObject = {
      totalItems: this.data.length,
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      totalPages: Math.ceil(this.data.length / this.pageSize)
    };
  }

  setNewPageintaionObject(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endindex = this.currentPage * this.pageSize;
    if (this.studentData.length > 0) {
      this.newStudentData = this.studentData.slice(startIndex, endindex);
    }
    this.paginationNewObject = {
      totalItems: this.studentData.length,
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      totalPages: Math.ceil(this.studentData.length / this.pageSize)
    };
  } 

  filteredList(filterData:any){
    let FilterArray: any = [];
    studentData.map((innerData: any) => {
      let flag = false;
      innerData.rowsData.map((data: any) => {
        if (data.headerId === "feedBack") {
          data.items.map(function (result: any) {
         if(result.values.link.label=== filterData.label){
          flag=true
         }
          });
        }
      });
      if (flag) {
        FilterArray.push(innerData);
      }
    });

    this.studentData = FilterArray;
  }

  sortStudentData(event: any) {
   const direction =  event.id === 'a-z'? 1 : -1
    of('Observable To sorting data').pipe(delay(0)).subscribe(() => {
      this.studentData.sort(function (a: any, b: any) {
        if (a.id < b.id) {
          return -1 * direction;
        }
        else if (a.id > b.id) {
          return 1 * direction;
        }
        else {
          return 0;
        }
      });

    });
  }

  viewbyList(data:any){
    this.studentData.map((obj:any) => {
      obj['check'] = obj.rowsData.find((items:any)=>items.subHeaderId === data.id).items[0].values.text.split('/')[0]
    })
    of('Observable To sorting data').pipe(delay(0)).subscribe(() => {
      this.studentData.sort( this.GetSortOrder("check") );
    });    
  }

  GetSortOrder(prop:any){
    return (a:any,b:any) => {
       if( a[prop] > b[prop]){
           return 1;
       }else if( a[prop] < b[prop] ){
           return -1;
       }
       return 0;
    }
  } 

  sortEvent(event: any, tableId?:string) {
    of('Observable To sorting data').pipe(delay(100)).subscribe(() => {
      if(tableId === 'sampleTable'){
        this.isDesc = !this.isDesc;
        this.column = event;
        let direction = this.isDesc ? 1 : -1;
        this.data.sort(function (a: any, b: any) {
          if (a[event] < b[event]) {
            return -1 * direction;
          }
          else if (a[event] > b[event]) {
            return 1 * direction;
          }
          else {
            return 0;
          }
        });
      }
      if(tableId === 'sampleTable1'){
        this.isDesc = !this.isDesc;
        this.column = event;
        let direction = this.isDesc ? 1 : -1;
        this.dataWithoutNumerics.sort(function (a: any, b: any) {
          if (a[event] < b[event]) {
            return -1 * direction;
          }
          else if (a[event] > b[event]) {
            return 1 * direction;
          }
          else {
            return 0;
          }
        });
      }

      if(tableId === 'sampleTable2'){
        this.isDesc = !this.isDesc;
        this.column = event;
        let direction = this.isDesc ? 1 : -1;
        this.tableDataWithText.sort(function (a: any, b: any) {
          if (a[event] < b[event]) {
            return -1 * direction;
          }
          else if (a[event] > b[event]) {
            return 1 * direction;
          }
          else {
            return 0;
          }
        });
      }
      if(tableId === 'sampleTable3'){
        if (this.currentSortKey === event) {
          this.sortDirection = (this.sortDirection === 'asc') ? 'desc' : 'asc';
        } else {
          this.currentSortKey = event;
          this.sortDirection = 'asc';
        }
      const parents = this.rowsData.filter(row => !row.isChild);
      const children = this.rowsData.filter(row => row.isChild);
      parents.sort((a, b) => {
        const valA = (event === 'teacher') ? a.teacher?.title : a[event]?.title;
        const valB = (event === 'teacher') ? b.teacher?.title : b[event]?.title;
        if (!valA || !valB) return 0;
        const compareResult = valA.localeCompare(valB);
        return (this.sortDirection === 'asc') ? compareResult : -compareResult;
      });
      const sortedList: any[] = [];
      parents.forEach(parent => {
        sortedList.push(parent);
        const relatedChildren = children.filter(c => {
          return c.id.startsWith(parent.id + '.');
        });
        sortedList.push(...relatedChildren);
      });
      this.rowsData = sortedList;
      }
    });
  };

  doOnClearSearch(){
    this.studentData = studentData;
  }

  buttonLabelText(){
    let labelText;
    if(this.selectedFilterList && this.selectedFilterList.length > 0){
      labelText = 'Filter'+'('+ this.selectedFilterList.length +')';
    } else{
      labelText = 'Filter';
    }
    return labelText;
  }

  setPageSizeList(): void {
    this.pageSizeList = [
      {
        id: '5',
        name: '5',
        label: '5 Items',
        active: false,
        url: this.currentUrl
      },
      {
        id: '10',
        name: '10',
        label: '10 Items',
        active: false,
        url: this.currentUrl
      },
      {
        id: '15',
        name: '15',
        label: '15 Items',
        active: false,
        url: this.currentUrl
      }
    ]
  }

  onChange(): void {
    this.hasDigitalTest = this.newData.filter((col: { radioChecked: string; }) => col.radioChecked === 'Digital Test').length !== 0 ? false : true;
    this.hasPaperTest = this.newData.filter((col: { radioChecked: string; }) => col.radioChecked === 'Paper Test').length !== 0 ? false : true;
    this.options1.forEach((item) => {
      if (item.label === 'Digital Test') {
        item.disabled = this.hasDigitalTest
      } else {
        item.disabled = this.hasPaperTest
      }
    })
    let selectedRowsCount = this.data.filter((obj: any) => obj.checked).length;
    if (selectedRowsCount !== 0) {
      this.label = selectedRowsCount + ' items Selected';
    } else {
      this.label = '0 items Selected';
    }
  }

  onClick(): void {
    this.selectedList = this.data.filter((obj: any) => obj.checked);
  }

  filterMobileView(){
      this.sortByDropdown.forEach((dropdownObj) => {
        this.sortByList.forEach((obj) => {
          if(dropdownObj.label === obj.label){
            if(dropdownObj.active === true){
              obj.checked = dropdownObj.label;
            } else {
              obj.checked = '';
            }
          }     
        });
      });
      this.viewBydropdown.forEach((dropdownObj) => {
        this.viewByList.forEach((obj) => {
          if(dropdownObj.label === obj.label){
            if(dropdownObj.active === true){
              obj.checked = dropdownObj.label;
            } else {
              obj.checked = '';
            }
          } 
        }); 
      });
  }
  
  singleCheckbox(item: any, value: string, event: any): void {
    const valueType = event.target.type;
    if (value === 'viewBy') {
      let selectedRadioData
      this.viewByList.forEach((obj: any) => {
        if (valueType == 'radio' && item.label === obj.label) {
          obj.checked = event.target.value;
          selectedRadioData = obj;          
        } else {
          obj.checked = '';
        }
      });
      this.viewbyList(selectedRadioData);
    }
    if (value === 'sortBy') {
      this.sortByList.forEach((obj: any) => {
        if (valueType == 'radio' && item.label === obj.label) {
          obj.checked = event.target.value;
          this.sortStudentData(obj);
        } else {
          obj.checked = '';
        }
      });
    }
  }

  onSearchSubmit(event: any) {
    this.isSearch = true;
    let FilterArray: any = [];
    studentData.map((innerData: any) => {
      let flag = false;
      innerData.rowsData.map((data: any) => {
        if (data.headerId === "studentName") {
          data.items.map(function (result: any) {
            result.values.text.toLowerCase().split(' ').map((data: any) => {
              event.split(' ').forEach((q: any) => {
                let match = data.match(q.toLowerCase());
                if (match && data === match.input) {
                  flag = true;
                }
              });
            });
          });
        }
      });
      if (flag) {
        FilterArray.push(innerData);
      }
    });
    this.studentData = FilterArray;
  }

  checkboxClickEvent(event: any) {
    console.log('event ==>', event);
    this.numaricLabel = event.length + ' questions Selected';
  }
}